module.exports = __webpack_public_path__ + "img/10892_L.5c0c8825.png";